import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { CONTACT } from "../../lib/content";

const scrollTo = (hash) => {
  if (window.__lenis) window.__lenis.scrollTo(hash, { offset: -60, duration: 1.4 });
  else document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
};

export const MobileBookBar = () => {
  // Hide once the contact section is visible (the form itself has a CTA there)
  // Also hide until user scrolls past the hero.
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hero = document.querySelector("#hero");
    const contact = document.querySelector("#contact");
    if (!hero || !contact) return;

    let heroVisible = true;
    let contactVisible = false;
    const update = () => setVisible(!heroVisible && !contactVisible);

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.target === hero) heroVisible = e.isIntersecting;
          if (e.target === contact) contactVisible = e.isIntersecting;
        });
        update();
      },
      { threshold: 0.15 }
    );
    io.observe(hero);
    io.observe(contact);
    return () => io.disconnect();
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="mobile-book-bar"
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-0 inset-x-0 z-40 md:hidden border-t border-[rgba(28,22,16,0.12)] bg-[#f7f6f2]/95 backdrop-blur-md"
          style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        >
          <div className="flex items-stretch h-14">
            <a
              data-testid="mobile-book-bar-whatsapp"
              href={CONTACT.whatsapp}
              target="_blank"
              rel="noreferrer"
              aria-label="Chat on WhatsApp"
              className="w-14 flex items-center justify-center text-[#1c1610] border-r border-[rgba(28,22,16,0.12)] active:bg-[rgba(28,22,16,0.05)]"
            >
              <MessageCircle size={18} />
            </a>
            <button
              data-testid="mobile-book-bar-cta"
              onClick={() => scrollTo("#contact")}
              className="flex-1 font-mono text-xs tracking-[0.25em] uppercase bg-[#1c1610] text-[#f7f6f2] active:bg-[#DB0909] transition-colors duration-300"
            >
              Book a Spot →
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
